var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"login-success min-h-screen min-w-full bg-base-300 flex items-center justify-center"},[_c('div',{staticClass:"card bg-white text-center shadow-2xl"},[_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Please wait...")]),_c('div',{staticClass:"justify-center card-actions"},[_c('Loader')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }